import React, { useState, useEffect, useMemo } from 'react';
import { formatTimeTo12Hour } from '../../../../../../utils/utils';

export const TimeSlotSelection = ({ 
    selectedDuration, 
    selectedDate, 
    handleSlotClick, 
    tutorId, 
    selectedSlot,
    filteredSlots, // Add this prop
    hideDuration = false // Add this prop for reschedule
}) => {
    const [selectedTimeSlotId, setSelectedTimeSlotId] = useState(null);

    // Sync with parent selectedSlot
    useEffect(() => {
        if (selectedSlot) {
            setSelectedTimeSlotId(selectedSlot.id);
        } else {
            setSelectedTimeSlotId(null);
        }
    }, [selectedSlot]);

    // Use filteredSlots passed from parent instead of fetching
    const availableSlots = filteredSlots || [];

    const handleTimeSlotClick = (slot) => {
        if (selectedTimeSlotId === slot.id) {
            setSelectedTimeSlotId(null);
            handleSlotClick(null);
        } else {
            setSelectedTimeSlotId(slot.id);
            handleSlotClick({
                slotId: slot.slotId,
                id: slot.id,
                startTime: slot.startTime,
                endTime: slot.endTime,
                duration: slot.duration,
                price: slot.price,
                subjectId: null,
                proficiency: null
            });
        }
    };

    if (availableSlots.length === 0) {
        return (
            <div className="time-slot-selection">
                <h3 className="ps-3 py-3 pt-md-0">
                    Available Slots
                    {selectedDuration && ` (${selectedDuration.duration} minutes)`}
                </h3>
                <div className="alert alert-info">
                    No available slots for this date and duration. Please select another date or duration.
                </div>
            </div>
        );
    }

    return (
        <div className="time-slot-selection">
            <h3 className="ps-3 py-3 pt-md-0">
                Available Slots
                {!hideDuration && selectedDuration && ` (${selectedDuration.duration} minutes)`}
            </h3>
            <p className="ps-3 text-muted">Click on a time slot to select it</p>
            <div className="d-flex gap-2 gap-sm-2 flex-wrap overflow-auto justify-content-center" style={{ maxHeight: '325px' }}>
                {availableSlots.map((slot) => (
                    <button
                        key={slot.id}
                        className={`btn ${selectedTimeSlotId === slot.id ? 'btn-primary' : 'btn-outline-primary'} rounded-pill py-2`}
                        style={{ width: '110px' }}
                        disabled={slot.sessionStatus === "Booked"}
                        onClick={() => handleTimeSlotClick(slot)}
                        title={slot.sessionStatus === "Booked" ? "This slot is already booked" : ""}
                    >
                        {formatTimeTo12Hour(slot.startTime)}
                    </button>
                ))}
            </div>
        </div>
    );
};